import * as React from 'react';
import { TextField } from '@mui/material';
import { Button, ThemeTextSize } from '.';
import AppService, { textsize } from '../services/app.service';

interface Props {
  id?: string;
  name: string;
  label?: string;
  placeHolder?: string;
  value?: string;
  size?: textsize;
  autoSelect?: boolean;
  box?: boolean;
  color?: any;
  readOnly?: boolean;
  disableMargin?: boolean;
  onBlur?: (fieldName?: string, value?: string) => void;
  onChange?: (fieldName: string, value?: string) => void;
  onClick?: () => void;
  onEndTyping?: (fieldName?: string, value?: string) => void;
  error?: string;
}

export const InputSearch: React.FunctionComponent<Props> = (props) => {
  const [endTyping, setEndTyping] = React.useState<any>(null);
  const isMobile = AppService.isMobile();

  const fontSize = (size?: textsize) => {
    return ThemeTextSize(size || props.size).fontSize;
  }
  
  const onBlur = (e: React.FocusEvent<HTMLInputElement>) => { 
    props.onBlur?.(props.name, e?.target.value);
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => { 
    props.onChange?.(props.name, e?.target.value);
   
    if (props.onEndTyping && e?.target.value) {
      clearTimeout(endTyping);
      setEndTyping(setTimeout(() => props.onEndTyping?.(props.name, e?.target.value), 500));
    }
  }

  
  return (
    <TextField 
      id={props.id || props.name}
      name={props.name}
      label={props.label}
      type='input'
      value={props.value?.toString()}
      placeholder={props.placeHolder || 'Search..'}
      inputProps={{spellCheck: false}}
      InputProps={{
        readOnly: props.readOnly || false,
        sx: {borderColor: 'primary.main', fontSize: fontSize(), borderRadius: 20, height: 35, bgcolor: props.color,},
        endAdornment: 
          <>
          {props.value &&
            <Button startIcon='clear' size='extrasmall' disablePadding onClick={() => props.onChange?.('','')} />
          }
          <Button startIcon='search' disablePadding onClick={props.onClick} />
          </>,
      }}
      InputLabelProps={{
        shrink: true,
        sx: {fontSize: fontSize() + (isMobile? 0 : 2), left: props.box? -7 : 0}
      }}
      FormHelperTextProps={{
        sx: {fontSize: fontSize(isMobile? 'medium' : 'small')}
      }}
      sx = {{
        '& legend': {width: props.box? 0 : undefined},
        '.MuiOutlinedInput-root:hover': {fieldset: {borderColor: 'primary.main'}}
      }}
      margin={props.disableMargin? 'none' : 'normal'}
      fullWidth
      helperText={props.error}
      error= {props.error? true: false}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={e => {props.autoSelect && e?.target.select();}}
    />
  )
}